import createFetchActions from './createFetchActions';

const fetchQuestionListActions = createFetchActions('QUESTIONS_LIST');

export { fetchQuestionListActions };
